import { useEffect, useMemo, useState } from "react";
import { IMenuOption } from "../../../types/global";
import { useTranslation } from "react-i18next";

export const useSalesReturnOption = (status?: string | null) => {
  const { t } = useTranslation();
  const defaultOptions: IMenuOption[] = useMemo(
    () => [
      {
        value: "แก้ไข",
        disabled: false,
      },
      {
        value: "ยกเลิก",
        disabled: false,
      },
    ],
    []
  );

  const [selectModifyOptions, setSelectedModifyOptions] =
    useState<IMenuOption[]>(defaultOptions);

  useEffect(() => {
    switch (status) {
      case "draft":
      case "not_approved":
        setSelectedModifyOptions([defaultOptions[1]]); //ยกเลิก
        break;
      case "cancelled":
        setSelectedModifyOptions([]);
        break;
      case "approved":
        setSelectedModifyOptions([
          {
            value: t("sales.external_reference_no"),
            disabled: false,
          },
          ...defaultOptions,
        ]);
        break;
      case "finished":
        setSelectedModifyOptions([
          {
            value: t("sales.external_reference_no"),
            disabled: false,
          },
        ]);
        break;
      default:
        setSelectedModifyOptions(defaultOptions);
        break;
    }
  }, [defaultOptions, status, t]);

  return selectModifyOptions;
};
